import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { MACHINE_GROUP } from '../types/machine-group.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for MachineGroup entity.
 * Stored in 'org/{orgId}/machine-group'.
 */
export const machineGroupDescriptor = {
    name: MACHINE_GROUP,
    label: 'Grupo de máquinas',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/machine-group',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Group/category of machines',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique machine group identifier',
        },
        {
            name: 'code',
            example: 3,
            label: 'Código',
            type: 'number',
            display: 'code',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric machine-group code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            example: 'Jets de tingimento',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Machine group description',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=machine-group.descriptor.js.map